import { User } from "types";

export function featureEnabled(currentUser: User | undefined | null, featureName: string) {
  if (currentUser?.featureFlags?.includes(featureName)) {
    return true
  } else { 
    return false
  } 
}